import { caretDown1_12 as caret } from '@trv-ebus/tds-icons';

function caretBackgroundImage() {
  return `url(data:image/svg+xml,${encodeURI(caret.contents)})`;
}

export default caretBackgroundImage;
